import desktopop_0 from "../../images/projects/desktopop/0.PNG";
import desktopop_1 from "../../images/projects/desktopop/1.PNG";
import desktopop_2 from "../../images/projects/desktopop/2.PNG";
import desktopop_3 from "../../images/projects/desktopop/3.PNG";
import desktopop_4 from "../../images/projects/desktopop/4.PNG";
import desktopop_5 from "../../images/projects/desktopop/5.PNG";
import desktopop_6 from "../../images/projects/desktopop/6.PNG";
import desktopop_7 from "../../images/projects/desktopop/7.PNG";

export default function desktopopImages() {
  return [
    desktopop_0,
    desktopop_1,
    desktopop_2,
    desktopop_3,
    desktopop_4,
    desktopop_5,
    desktopop_6,
    desktopop_7,
  ];
}
